import { useEffect, useMemo, useState } from 'react';

export const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'zh', label: '中文' },
  { code: 'es', label: 'ES' },
  { code: 'ko', label: '한국어' },
  { code: 'ja', label: '日本語' },
];

const DICT = {
  zh: {
    Dashboard: '仪表板',
    Rewards: '奖励',
    Customers: '客户',
    Campaigns: '营销活动',
    'AI Insights': 'AI 洞察',
    Overview: '概览',
    Loyalty: '忠诚度',
    Logout: '退出登录',
    'Customer Old': '旧客户页',
    Settings: '设置',
    'Ask AI': '询问 AI',
    'Know More': '了解更多',
    'Run Campaign': '运行活动',
    'Run Promo': '运行促销',
    'Credit Points': '发放积分',
    Redeem: '兑换',
    Approve: '批准',
    Reject: '拒绝',
    'Customer-Initiated Queue': '客户发起队列',
    'No pending redemption requests.': '暂无待处理兑换请求。',
    'Voice Agent Loyalty Connect (Coming Soon)': '语音忠诚度助手（即将推出）',
    'Get onboarded in 5 minutes': '5 分钟快速入驻',
    'POS Ready': 'POS 就绪',
    '5-Min Setup': '5 分钟配置',
    'Dynamic performance overview for the last': '过去时间范围的动态表现概览',
    'Export CSV': '导出 CSV',
    'Show QR': '显示二维码',
    'New Enrolments vs Guests': '新注册与访客',
    guests: '访客',
    'AOV (Average Order Value)': '客单价（AOV）',
    'Calculated from recent completed loyalty visits.': '基于近期完成的忠诚度到店计算',
    'Active Customers': '活跃顾客',
    'Last 7 days / Last 30 days': '近7天 / 近30天',
    'Visit Frequency': '到店频次',
    'Visits per active customer': '每位活跃顾客到店次数',
    'Campaign Metrics': '活动指标',
    Redemptions: '核销数',
    'New users': '新用户',
    'Revenue impact': '营收影响',
    'Redemption Rate': '兑换率',
    '(points redeemed / points issued) * 100': '（已兑换积分 / 已发放积分）* 100',
    'Avg Spend / Visit': '每次到店平均消费',
    'Across selected range': '所选时间范围内',
    'Visits per Day': '每日到店',
    'Daily visit trend for selected range': '所选范围每日到店趋势',
    Hello: '你好',
    Merchant: '商家',
    '7 days': '7天',
    '30 days': '30天',
    '90 days': '90天',
    '13 active members in last 30 days.': '过去30天有13位活跃会员。',
    'Revenue Split': '营收拆分',
    'Total Revenue': '总营收',
    'Via Loyalty Points': '来自积分会员',
    'Without Loyalty': '非会员营收',
    'Live Pulse': '实时脉搏',
    'Avg. Order Value': '平均客单价',
    'Total Customers': '总客户数',
    'Total Visits': '总到访数',
    Ask: '询问',
    'Turn casual diners into': '让普通食客变成',
    'loyal regulars.': '忠实回头客。',
    'The AI-powered loyalty platform designed for restaurant owners. Set up in minutes, integrate with your POS, and watch retention grow.': '面向餐厅老板的 AI 忠诚度平台。几分钟完成配置，连接 POS，提升复购率。',
    'Get started': '开始使用',
    'Already have an account?': '已有账号？',
    'Sign in': '登录',
    'Owner Name': '店主姓名',
    Email: '邮箱',
    Password: '密码',
    'Enter your password': '输入密码',
    'Create account': '创建账号',
    "Don't have an account?": '还没有账号？',
    'By continuing, you agree to FlyBack Terms and Privacy Policy.': '继续即表示你同意 FlyBack 条款和隐私政策。',
    'Step 1': '第1步',
    'Step 2': '第2步',
    'Step 3': '第3步',
    'Step 1 of 4': '第1步（共4步）',
    'Step 2 of 4': '第2步（共4步）',
    'Step 3 of 4': '第3步（共4步）',
    "Let's set up your restaurant.": '开始设置你的餐厅。',
    'Simple setup for restaurant profile, branding, and guest onboarding QR.': '快速完成餐厅资料、品牌和顾客入驻二维码设置。',
    'Restaurant Name': '餐厅名称',
    'e.g. The Daily Grind': '例如：The Daily Grind',
    'Cuisine Type': '菜系类型',
    'Select all that apply': '可多选',
    'Add custom cuisine (optional)': '添加自定义菜系（可选）',
    'Restaurant Logo': '餐厅Logo',
    Optional: '可选',
    'Logo uploaded': 'Logo已上传',
    'Click to upload or drag and drop': '点击上传或拖拽文件',
    'SVG, PNG, JPG, GIF or WEBP (max 800x400px)': '支持 SVG/PNG/JPG/GIF/WEBP（最大800x400）',
    'Menu Upload (PDF)': '菜单上传（PDF）',
    Uploaded: '已上传',
    'Upload Menu PDF': '上传菜单PDF',
    'Next Step': '下一步',
    'Where are you located?': '你的餐厅位置在哪里？',
    'Help customers find your restaurant and enable location-based rewards.': '帮助顾客找到你的餐厅，并启用基于位置的奖励。',
    'Google Places': 'Google 地点',
    'Coming Soon': '即将推出',
    'Search via Google Places (coming soon)': '通过 Google Places 搜索（即将推出）',
    'Restaurant Address': '餐厅地址',
    'Start typing your address...': '开始输入地址...',
    'Opening Time (HH:mm:ss)': '营业开始时间（HH:mm:ss）',
    'Closing Time (HH:mm:ss)': '营业结束时间（HH:mm:ss）',
    City: '城市',
    State: '州/省',
    'ZIP Code': '邮编',
    'Contact Information': '联系信息',
    'Phone Number': '手机号',
    'Email (Optional)': '邮箱（可选）',
    'Confirm Details': '确认信息',
    'Review your restaurant information before finalizing the setup.': '完成前请确认餐厅信息。',
    'Not selected': '未选择',
    Location: '位置',
    'Not provided': '未提供',
    Hours: '营业时间',
    'Menu PDF': '菜单 PDF',
    'Not uploaded': '未上传',
    Contact: '联系方式',
    'Save and continue': '保存并继续',
    'Your QR Code is Ready': '你的二维码已准备好',
    'Turn every visit into rewards. Scan. Dine. Earn Points Instantly.': '让每次到店都有奖励。扫码、用餐、即时得分。',
    'Your Restaurant': '你的餐厅',
    'Get rewarded every time you eat here.': '每次来店消费都可获得奖励。',
    'Powered by FlyBack': '由 FlyBack 提供支持',
    'Download QR': '下载二维码',
    'Share Link': '分享链接',
    'Continue to Dashboard': '进入仪表板',
  },
  es: {
    Dashboard: 'Panel',
    Rewards: 'Recompensas',
    Customers: 'Clientes',
    Campaigns: 'Campañas',
    'AI Insights': 'Insights IA',
    Overview: 'Resumen',
    Loyalty: 'Lealtad',
    Logout: 'Cerrar sesión',
    'Customer Old': 'Clientes Antiguo',
    Settings: 'Configuración',
    'Ask AI': 'Preguntar a IA',
    'Know More': 'Saber más',
    'Run Campaign': 'Ejecutar campaña',
    'Run Promo': 'Lanzar promo',
    'Credit Points': 'Acreditar puntos',
    Redeem: 'Canjear',
    Approve: 'Aprobar',
    Reject: 'Rechazar',
    'Customer-Initiated Queue': 'Cola iniciada por clientes',
    'No pending redemption requests.': 'No hay solicitudes de canje pendientes.',
    'Voice Agent Loyalty Connect (Coming Soon)': 'Agente de Voz Loyalty Connect (Próximamente)',
    'Get onboarded in 5 minutes': 'Actívate en 5 minutos',
    'POS Ready': 'POS listo',
    '5-Min Setup': 'Setup de 5 min',
    'Dynamic performance overview for the last': 'Resumen dinámico del rendimiento para los últimos',
    'Export CSV': 'Exportar CSV',
    'Show QR': 'Mostrar QR',
    'New Enrolments vs Guests': 'Nuevos registros vs invitados',
    guests: 'invitados',
    'AOV (Average Order Value)': 'AOV (Ticket promedio)',
    'Calculated from recent completed loyalty visits.': 'Calculado a partir de visitas de lealtad completadas recientemente.',
    'Active Customers': 'Clientes activos',
    'Last 7 days / Last 30 days': 'Últimos 7 días / Últimos 30 días',
    'Visit Frequency': 'Frecuencia de visita',
    'Visits per active customer': 'Visitas por cliente activo',
    'Campaign Metrics': 'Métricas de campaña',
    Redemptions: 'Canjes',
    'New users': 'Nuevos usuarios',
    'Revenue impact': 'Impacto en ingresos',
    'Redemption Rate': 'Tasa de canje',
    '(points redeemed / points issued) * 100': '(puntos canjeados / puntos emitidos) * 100',
    'Avg Spend / Visit': 'Gasto promedio / visita',
    'Across selected range': 'En el rango seleccionado',
    'Visits per Day': 'Visitas por día',
    'Daily visit trend for selected range': 'Tendencia diaria de visitas para el rango seleccionado',
    Hello: 'Hola',
    Merchant: 'Comerciante',
    '7 days': '7 días',
    '30 days': '30 días',
    '90 days': '90 días',
    '13 active members in last 30 days.': '13 miembros activos en los últimos 30 días.',
    'Revenue Split': 'Desglose de ingresos',
    'Total Revenue': 'Ingresos totales',
    'Via Loyalty Points': 'Vía puntos de lealtad',
    'Without Loyalty': 'Sin lealtad',
    'Live Pulse': 'Pulso en vivo',
    'Avg. Order Value': 'Valor promedio de pedido',
    'Total Customers': 'Total de clientes',
    'Total Visits': 'Total de visitas',
    Ask: 'Preguntar',
    'Turn casual diners into': 'Convierte comensales casuales en',
    'loyal regulars.': 'clientes fieles.',
    'The AI-powered loyalty platform designed for restaurant owners. Set up in minutes, integrate with your POS, and watch retention grow.': 'La plataforma de lealtad con IA para dueños de restaurantes. Configura en minutos, integra tu POS y mejora la retención.',
    'Get started': 'Comenzar',
    'Already have an account?': '¿Ya tienes cuenta?',
    'Sign in': 'Iniciar sesión',
    'Owner Name': 'Nombre del propietario',
    Email: 'Correo',
    Password: 'Contraseña',
    'Enter your password': 'Ingresa tu contraseña',
    'Create account': 'Crear cuenta',
    "Don't have an account?": '¿No tienes cuenta?',
    'By continuing, you agree to FlyBack Terms and Privacy Policy.': 'Al continuar, aceptas los Términos y la Política de privacidad de FlyBack.',
    'Step 1': 'Paso 1',
    'Step 2': 'Paso 2',
    'Step 3': 'Paso 3',
    'Step 1 of 4': 'Paso 1 de 4',
    'Step 2 of 4': 'Paso 2 de 4',
    'Step 3 of 4': 'Paso 3 de 4',
    "Let's set up your restaurant.": 'Configuremos tu restaurante.',
    'Simple setup for restaurant profile, branding, and guest onboarding QR.': 'Configuración simple de perfil, marca y QR para clientes.',
    'Restaurant Name': 'Nombre del restaurante',
    'e.g. The Daily Grind': 'ej. The Daily Grind',
    'Cuisine Type': 'Tipo de cocina',
    'Select all that apply': 'Selecciona todas las que apliquen',
    'Add custom cuisine (optional)': 'Agregar cocina personalizada (opcional)',
    'Restaurant Logo': 'Logo del restaurante',
    Optional: 'Opcional',
    'Logo uploaded': 'Logo cargado',
    'Click to upload or drag and drop': 'Haz clic para subir o arrastra el archivo',
    'SVG, PNG, JPG, GIF or WEBP (max 800x400px)': 'SVG, PNG, JPG, GIF o WEBP (máx. 800x400)',
    'Menu Upload (PDF)': 'Subir menú (PDF)',
    Uploaded: 'Subido',
    'Upload Menu PDF': 'Subir menú PDF',
    'Next Step': 'Siguiente paso',
    'Where are you located?': '¿Dónde estás ubicado?',
    'Help customers find your restaurant and enable location-based rewards.': 'Ayuda a los clientes a encontrarte y habilita recompensas por ubicación.',
    'Google Places': 'Google Places',
    'Coming Soon': 'Próximamente',
    'Search via Google Places (coming soon)': 'Buscar por Google Places (próximamente)',
    'Restaurant Address': 'Dirección del restaurante',
    'Start typing your address...': 'Comienza a escribir tu dirección...',
    'Opening Time (HH:mm:ss)': 'Hora de apertura (HH:mm:ss)',
    'Closing Time (HH:mm:ss)': 'Hora de cierre (HH:mm:ss)',
    City: 'Ciudad',
    State: 'Estado',
    'ZIP Code': 'Código postal',
    'Contact Information': 'Información de contacto',
    'Phone Number': 'Número de teléfono',
    'Email (Optional)': 'Correo (Opcional)',
    'Confirm Details': 'Confirmar detalles',
    'Review your restaurant information before finalizing the setup.': 'Revisa la información antes de finalizar.',
    'Not selected': 'No seleccionado',
    Location: 'Ubicación',
    'Not provided': 'No proporcionado',
    Hours: 'Horario',
    'Menu PDF': 'Menú PDF',
    'Not uploaded': 'No subido',
    Contact: 'Contacto',
    'Save and continue': 'Guardar y continuar',
    'Your QR Code is Ready': 'Tu código QR está listo',
    'Turn every visit into rewards. Scan. Dine. Earn Points Instantly.': 'Convierte cada visita en recompensas. Escanea, come y gana puntos al instante.',
    'Your Restaurant': 'Tu restaurante',
    'Get rewarded every time you eat here.': 'Obtén recompensas cada vez que comas aquí.',
    'Powered by FlyBack': 'Powered by FlyBack',
    'Download QR': 'Descargar QR',
    'Share Link': 'Compartir enlace',
    'Continue to Dashboard': 'Ir al panel',
  },
  ko: {
    Dashboard: '대시보드',
    Rewards: '리워드',
    Customers: '고객',
    Campaigns: '캠페인',
    'AI Insights': 'AI 인사이트',
    Overview: '개요',
    Loyalty: '로열티',
    Logout: '로그아웃',
    'Customer Old': '기존 고객',
    Settings: '설정',
    'Ask AI': 'AI에게 묻기',
    'Know More': '자세히 보기',
    'Run Campaign': '캠페인 실행',
    'Run Promo': '프로모션 실행',
    'Credit Points': '포인트 적립',
    Redeem: '사용',
    Approve: '승인',
    Reject: '거절',
    'Customer-Initiated Queue': '고객 요청 대기열',
    'No pending redemption requests.': '대기 중인 요청이 없습니다.',
    'Voice Agent Loyalty Connect (Coming Soon)': '보이스 에이전트 로열티 커넥트 (출시 예정)',
    'Get onboarded in 5 minutes': '5분 내 온보딩',
    'POS Ready': 'POS 준비됨',
    '5-Min Setup': '5분 설정',
    'Dynamic performance overview for the last': '최근 기간의 동적 성과 요약',
    'Export CSV': 'CSV 내보내기',
    'Show QR': 'QR 보기',
    'New Enrolments vs Guests': '신규 가입 vs 게스트',
    guests: '게스트',
    'AOV (Average Order Value)': 'AOV (평균 주문 금액)',
    'Calculated from recent completed loyalty visits.': '최근 완료된 로열티 방문 기준 계산',
    'Active Customers': '활성 고객',
    'Last 7 days / Last 30 days': '최근 7일 / 최근 30일',
    'Visit Frequency': '방문 빈도',
    'Visits per active customer': '활성 고객당 방문 수',
    'Campaign Metrics': '캠페인 지표',
    Redemptions: '사용 수',
    'New users': '신규 사용자',
    'Revenue impact': '매출 영향',
    'Redemption Rate': '리딤 비율',
    '(points redeemed / points issued) * 100': '(사용 포인트 / 발행 포인트) * 100',
    'Avg Spend / Visit': '방문당 평균 지출',
    'Across selected range': '선택한 기간 기준',
    'Visits per Day': '일별 방문',
    'Daily visit trend for selected range': '선택한 기간의 일별 방문 추이',
    Hello: '안녕하세요',
    Merchant: '가맹점',
    '7 days': '7일',
    '30 days': '30일',
    '90 days': '90일',
    '13 active members in last 30 days.': '최근 30일 활성 회원 13명',
    'Revenue Split': '매출 분할',
    'Total Revenue': '총매출',
    'Via Loyalty Points': '로열티 포인트 경유',
    'Without Loyalty': '비로열티 매출',
    'Live Pulse': '실시간 펄스',
    'Avg. Order Value': '평균 주문 금액',
    'Total Customers': '총 고객 수',
    'Total Visits': '총 방문 수',
    Ask: '질문',
    'Turn casual diners into': '일반 방문 고객을',
    'loyal regulars.': '충성 단골로 전환하세요.',
    'The AI-powered loyalty platform designed for restaurant owners. Set up in minutes, integrate with your POS, and watch retention grow.': '레스토랑 사장님을 위한 AI 로열티 플랫폼입니다. 몇 분 만에 설정하고 POS와 연동해 재방문을 높이세요.',
    'Get started': '시작하기',
    'Already have an account?': '이미 계정이 있나요?',
    'Sign in': '로그인',
    'Owner Name': '오너 이름',
    Email: '이메일',
    Password: '비밀번호',
    'Enter your password': '비밀번호를 입력하세요',
    'Create account': '계정 만들기',
    "Don't have an account?": '계정이 없나요?',
    'By continuing, you agree to FlyBack Terms and Privacy Policy.': '계속하면 FlyBack 이용약관 및 개인정보처리방침에 동의합니다.',
    'Step 1': '1단계',
    'Step 2': '2단계',
    'Step 3': '3단계',
    'Step 1 of 4': '1 / 4 단계',
    'Step 2 of 4': '2 / 4 단계',
    'Step 3 of 4': '3 / 4 단계',
    "Let's set up your restaurant.": '레스토랑을 설정해볼까요?',
    'Simple setup for restaurant profile, branding, and guest onboarding QR.': '프로필, 브랜딩, 게스트 QR 온보딩을 간단히 설정합니다.',
    'Restaurant Name': '레스토랑 이름',
    'e.g. The Daily Grind': '예: The Daily Grind',
    'Cuisine Type': '요리 유형',
    'Select all that apply': '해당되는 항목 모두 선택',
    'Add custom cuisine (optional)': '직접 입력 (선택)',
    'Restaurant Logo': '레스토랑 로고',
    Optional: '선택',
    'Logo uploaded': '로고 업로드됨',
    'Click to upload or drag and drop': '클릭 또는 드래그로 업로드',
    'SVG, PNG, JPG, GIF or WEBP (max 800x400px)': 'SVG, PNG, JPG, GIF, WEBP (최대 800x400)',
    'Menu Upload (PDF)': '메뉴 업로드 (PDF)',
    Uploaded: '업로드됨',
    'Upload Menu PDF': '메뉴 PDF 업로드',
    'Next Step': '다음 단계',
    'Where are you located?': '위치가 어디인가요?',
    'Help customers find your restaurant and enable location-based rewards.': '고객이 매장을 찾고 위치 기반 보상을 받을 수 있게 설정하세요.',
    'Google Places': 'Google Places',
    'Coming Soon': '출시 예정',
    'Search via Google Places (coming soon)': 'Google Places 검색 (출시 예정)',
    'Restaurant Address': '매장 주소',
    'Start typing your address...': '주소를 입력하세요...',
    'Opening Time (HH:mm:ss)': '오픈 시간 (HH:mm:ss)',
    'Closing Time (HH:mm:ss)': '마감 시간 (HH:mm:ss)',
    City: '도시',
    State: '주/도',
    'ZIP Code': '우편번호',
    'Contact Information': '연락처 정보',
    'Phone Number': '전화번호',
    'Email (Optional)': '이메일 (선택)',
    'Confirm Details': '세부 정보 확인',
    'Review your restaurant information before finalizing the setup.': '설정 완료 전 정보를 확인하세요.',
    'Not selected': '선택 안됨',
    Location: '위치',
    'Not provided': '미입력',
    Hours: '영업시간',
    'Menu PDF': '메뉴 PDF',
    'Not uploaded': '미업로드',
    Contact: '연락처',
    'Save and continue': '저장 후 계속',
    'Your QR Code is Ready': 'QR 코드가 준비되었습니다',
    'Turn every visit into rewards. Scan. Dine. Earn Points Instantly.': '모든 방문을 보상으로 바꾸세요. 스캔하고 식사하고 즉시 포인트 적립.',
    'Your Restaurant': '내 레스토랑',
    'Get rewarded every time you eat here.': '방문할 때마다 보상을 받으세요.',
    'Powered by FlyBack': 'Powered by FlyBack',
    'Download QR': 'QR 다운로드',
    'Share Link': '링크 공유',
    'Continue to Dashboard': '대시보드로 이동',
  },
  ja: {
    Dashboard: 'ダッシュボード',
    Rewards: 'リワード',
    Customers: '顧客',
    Campaigns: 'キャンペーン',
    'AI Insights': 'AIインサイト',
    Overview: '概要',
    Loyalty: 'ロイヤルティ',
    Logout: 'ログアウト',
    'Customer Old': '旧顧客',
    Settings: '設定',
    'Ask AI': 'AIに質問',
    'Know More': '詳しく見る',
    'Run Campaign': 'キャンペーン実行',
    'Run Promo': 'プロモ実行',
    'Credit Points': 'ポイント付与',
    Redeem: '交換',
    Approve: '承認',
    Reject: '却下',
    'Customer-Initiated Queue': '顧客リクエストキュー',
    'No pending redemption requests.': '保留中の交換リクエストはありません。',
    'Voice Agent Loyalty Connect (Coming Soon)': 'ボイスエージェント ロイヤルティコネクト（近日公開）',
    'Get onboarded in 5 minutes': '5分で導入完了',
    'POS Ready': 'POS 対応',
    '5-Min Setup': '5分セットアップ',
    'Dynamic performance overview for the last': '直近期間のパフォーマンス概要',
    'Export CSV': 'CSVをエクスポート',
    'Show QR': 'QRを表示',
    'New Enrolments vs Guests': '新規登録 vs ゲスト',
    guests: 'ゲスト',
    'AOV (Average Order Value)': 'AOV（平均注文額）',
    'Calculated from recent completed loyalty visits.': '直近の完了来店データから算出',
    'Active Customers': 'アクティブ顧客',
    'Last 7 days / Last 30 days': '過去7日 / 過去30日',
    'Visit Frequency': '来店頻度',
    'Visits per active customer': 'アクティブ顧客あたり来店数',
    'Campaign Metrics': 'キャンペーン指標',
    Redemptions: '利用件数',
    'New users': '新規ユーザー',
    'Revenue impact': '売上インパクト',
    'Redemption Rate': '交換率',
    '(points redeemed / points issued) * 100': '（交換ポイント / 発行ポイント）* 100',
    'Avg Spend / Visit': '来店あたり平均支出',
    'Across selected range': '選択期間ベース',
    'Visits per Day': '日別来店',
    'Daily visit trend for selected range': '選択期間の日別来店推移',
    Hello: 'こんにちは',
    Merchant: '加盟店',
    '7 days': '7日',
    '30 days': '30日',
    '90 days': '90日',
    '13 active members in last 30 days.': '過去30日でアクティブ会員13名',
    'Revenue Split': '売上内訳',
    'Total Revenue': '総売上',
    'Via Loyalty Points': 'ロイヤルティ経由',
    'Without Loyalty': '非ロイヤルティ売上',
    'Live Pulse': 'ライブパルス',
    'Avg. Order Value': '平均注文額',
    'Total Customers': '総顧客数',
    'Total Visits': '総来店数',
    Ask: '質問',
    'Turn casual diners into': 'カジュアル客を',
    'loyal regulars.': 'ロイヤル常連へ。',
    'The AI-powered loyalty platform designed for restaurant owners. Set up in minutes, integrate with your POS, and watch retention grow.': '飲食店オーナー向けAIロイヤルティ基盤。数分で設定しPOS連携、再来店を伸ばします。',
    'Get started': 'はじめる',
    'Already have an account?': 'すでにアカウントをお持ちですか？',
    'Sign in': 'サインイン',
    'Owner Name': 'オーナー名',
    Email: 'メール',
    Password: 'パスワード',
    'Enter your password': 'パスワードを入力',
    'Create account': 'アカウント作成',
    "Don't have an account?": 'アカウントをお持ちでないですか？',
    'By continuing, you agree to FlyBack Terms and Privacy Policy.': '続行するとFlyBackの利用規約とプライバシーポリシーに同意したことになります。',
    'Step 1': 'ステップ1',
    'Step 2': 'ステップ2',
    'Step 3': 'ステップ3',
    'Step 1 of 4': '4ステップ中1',
    'Step 2 of 4': '4ステップ中2',
    'Step 3 of 4': '4ステップ中3',
    "Let's set up your restaurant.": 'レストラン設定を始めましょう。',
    'Simple setup for restaurant profile, branding, and guest onboarding QR.': '店舗プロフィール、ブランド、ゲストQRを簡単設定。',
    'Restaurant Name': 'レストラン名',
    'e.g. The Daily Grind': '例: The Daily Grind',
    'Cuisine Type': '料理タイプ',
    'Select all that apply': '該当するものを選択',
    'Add custom cuisine (optional)': 'カスタム料理を追加（任意）',
    'Restaurant Logo': 'レストランロゴ',
    Optional: '任意',
    'Logo uploaded': 'ロゴアップロード済み',
    'Click to upload or drag and drop': 'クリックしてアップロード、またはドラッグ&ドロップ',
    'SVG, PNG, JPG, GIF or WEBP (max 800x400px)': 'SVG/PNG/JPG/GIF/WEBP（最大800x400）',
    'Menu Upload (PDF)': 'メニューアップロード（PDF）',
    Uploaded: 'アップロード済み',
    'Upload Menu PDF': 'メニューPDFをアップロード',
    'Next Step': '次へ',
    'Where are you located?': '所在地はどこですか？',
    'Help customers find your restaurant and enable location-based rewards.': 'お客様が店舗を見つけられるようにし、位置連動特典を有効化します。',
    'Google Places': 'Google Places',
    'Coming Soon': '近日公開',
    'Search via Google Places (coming soon)': 'Google Placesで検索（近日公開）',
    'Restaurant Address': 'レストラン住所',
    'Start typing your address...': '住所を入力してください...',
    'Opening Time (HH:mm:ss)': '開店時間 (HH:mm:ss)',
    'Closing Time (HH:mm:ss)': '閉店時間 (HH:mm:ss)',
    City: '市区町村',
    State: '都道府県',
    'ZIP Code': '郵便番号',
    'Contact Information': '連絡先情報',
    'Phone Number': '電話番号',
    'Email (Optional)': 'メール（任意）',
    'Confirm Details': '内容確認',
    'Review your restaurant information before finalizing the setup.': '完了前に店舗情報を確認してください。',
    'Not selected': '未選択',
    Location: '所在地',
    'Not provided': '未入力',
    Hours: '営業時間',
    'Menu PDF': 'メニューPDF',
    'Not uploaded': '未アップロード',
    Contact: '連絡先',
    'Save and continue': '保存して続行',
    'Your QR Code is Ready': 'QRコードの準備ができました',
    'Turn every visit into rewards. Scan. Dine. Earn Points Instantly.': '来店をすべて特典に。スキャンして食事、すぐにポイント獲得。',
    'Your Restaurant': 'あなたのレストラン',
    'Get rewarded every time you eat here.': '来店ごとに特典を獲得。',
    'Powered by FlyBack': 'Powered by FlyBack',
    'Download QR': 'QRをダウンロード',
    'Share Link': 'リンクを共有',
    'Continue to Dashboard': 'ダッシュボードへ',
  },
};

const EXTRA_DICT = {
  zh: {
    'Simulate order credits, redeem in person, and validate pending redemption requests.': '模拟订单积分发放、到店兑换并处理待审批兑换请求。',
    'Lookup customer by phone or name': '按手机号或姓名查找顾客',
    'Simulate & Credit': '模拟并发放',
    'Redeem In Person': '到店兑换',
    'Use Amount': '按金额',
    'Use Points': '按积分',
    'AI Tip': 'AI 提示',
    'Offering 10% bonus points increases return visits by ~20%.': '提供 10% 额外积分可将回访率提升约 20%。',
    'Requested Points': '申请积分',
    Channel: '渠道',
    'Created At': '创建时间',
    Actions: '操作',
    'Voice Agent Loyalty Connect': '语音忠诚度连接',
    "Powered by ISO's AI Agent": '由 ISO 的 AI 助手提供支持',
    'Auto-enroll via call: "You earned 500 points worth $5 — say YES to join".': '电话自动入会：“你已获得价值 $5 的 500 积分，回复 YES 加入”。',
    Agent: '助手',
    'All callers': '所有来电者',
    Members: '会员',
    'Lost bucket': '流失分组',
    'At Risk bucket': '风险分组',
    'Active bucket': '活跃分组',
    'Campaign Activity': '活动记录',
    'Campaign Details': '活动详情',
    'Delivery analytics and recipient status for this campaign.': '该活动的发送分析与接收人状态。',
    Targeted: '触达人数',
    Conversion: '转化率',
    Revenue: '营收',
    'Campaign Visits': '活动到店',
    'New Users': '新用户',
    'Delivery Log': '发送日志',
    'Provider SID': '服务商 SID',
    Error: '错误',
    Time: '时间',
    'No delivery records available yet.': '暂无发送记录。',
    'Eligible Customers': '符合条件的顾客',
    'Audience preview based on current campaign rules.': '基于当前活动规则的人群预览。',
    'No eligible customers found.': '未找到符合条件的顾客。',
    'Load More Campaigns': '加载更多活动',
    View: '查看',
    Code: '代码',
    Campaign: '活动',
    'Choose a campaign and run it in one click.': '选择活动并一键执行。',
    'Toggle Campaigns': '活动开关',
    Recommended: '推荐',
    'No campaigns found for this filter.': '当前筛选下暂无活动。',
    'Segment, act fast, and retain more regular diners.': '精细分群、快速行动，提升常客留存。',
    'Customer List': '顾客列表',
    'Customer Name': '顾客姓名',
    'Active Points (Lifetime)': '当前积分（累计）',
    'Total Spend with Rewards': '含奖励总消费',
    'Spend by Points': '积分抵扣消费',
    'Total Visits': '总到店',
    'Last Visit': '最近到店',
    'Upcoming event': '即将到来',
    'Birthday in': '生日还有',
    'Anniversary in': '纪念日还有',
    'Campaign Suggestion': '活动建议',
    'Select Customer': '选择顾客',
    Name: '姓名',
    Balance: '余额',
    'Points Earned': '已赚积分',
    Visits: '到店',
    'Visit History': '到店记录',
    Order: '订单',
    'No visits yet.': '暂无到店记录。',
    'Recent Transactions': '最近交易',
    'AI preferences saved': 'AI 偏好已保存',
    'Insights refreshed from latest 7-day data': '已根据最近 7 天数据刷新洞察',
    'Loyalty AI': '忠诚度 AI',
    'Daily Visits (Last 7 Days)': '每日到店（近 7 天）',
    'Revenue Trend (Last 7 Days)': '营收趋势（近 7 天）',
    'Customer Segments': '顾客分层',
    'Trend data unavailable': '暂无趋势数据',
    'No recommendation available.': '暂无建议。',
    'At-Risk Guests': '风险顾客',
    'Visit Growth': '到店增长',
    'Revenue (7d)': '营收（7天）',
    'Visits (7d)': '到店（7天）',
    'Context-aware restaurant advisor powered by your real business data.': '基于真实经营数据的上下文餐厅顾问。',
    pts: '分',
    'N/A': '无',
    'No customers yet': '暂无顾客',
    'No customers found.': '未找到顾客。',
    'Unable to load rewards data right now.': '当前无法加载奖励数据。',
    'Please enter a valid order amount.': '请输入有效订单金额。',
    'Order ID must follow ORD-123 format.': '订单号需符合 ORD-123 格式。',
    'Points credited successfully.': '积分发放成功。',
    'Minimum 100 points required.': '至少需要 100 积分。',
    'Redemption completed successfully.': '兑换成功完成。',
    'Unable to initiate redemption.': '无法发起兑换。',
  },
  es: {
    'Simulate order credits, redeem in person, and validate pending redemption requests.': 'Simula créditos de pedidos, canjea en persona y valida solicitudes pendientes.',
    'Lookup customer by phone or name': 'Buscar cliente por teléfono o nombre',
    'Simulate & Credit': 'Simular y acreditar',
    'Redeem In Person': 'Canjear en persona',
    'Use Amount': 'Usar monto',
    'Use Points': 'Usar puntos',
    'AI Tip': 'Tip de IA',
    'Offering 10% bonus points increases return visits by ~20%.': 'Ofrecer 10% de puntos extra aumenta las visitas de regreso ~20%.',
    'Requested Points': 'Puntos solicitados',
    Channel: 'Canal',
    'Created At': 'Creado',
    Actions: 'Acciones',
    'Voice Agent Loyalty Connect': 'Voice Agent Loyalty Connect',
    "Powered by ISO's AI Agent": 'Impulsado por el agente IA de ISO',
    'Auto-enroll via call: "You earned 500 points worth $5 — say YES to join".': 'Autoinscripción por llamada: "Ganaste 500 puntos ($5), di SÍ para unirte".',
    Agent: 'Agente',
    'All callers': 'Todos los llamantes',
    Members: 'Miembros',
    'Lost bucket': 'Segmento perdidos',
    'At Risk bucket': 'Segmento en riesgo',
    'Active bucket': 'Segmento activos',
    'Campaign Activity': 'Actividad de campañas',
    'Campaign Details': 'Detalles de campaña',
    'Delivery analytics and recipient status for this campaign.': 'Analítica de entrega y estado de destinatarios de esta campaña.',
    Targeted: 'Objetivo',
    Conversion: 'Conversión',
    Revenue: 'Ingresos',
    'Campaign Visits': 'Visitas por campaña',
    'New Users': 'Nuevos usuarios',
    'Delivery Log': 'Registro de entrega',
    'Provider SID': 'SID del proveedor',
    Error: 'Error',
    Time: 'Hora',
    'No delivery records available yet.': 'Aún no hay registros de entrega.',
    'Eligible Customers': 'Clientes elegibles',
    'Audience preview based on current campaign rules.': 'Vista previa de audiencia según reglas actuales.',
    'No eligible customers found.': 'No se encontraron clientes elegibles.',
    'Load More Campaigns': 'Cargar más campañas',
    View: 'Ver',
    Code: 'Código',
    Campaign: 'Campaña',
    'Choose a campaign and run it in one click.': 'Elige una campaña y ejecútala en un clic.',
    'Toggle Campaigns': 'Activar/Desactivar campañas',
    Recommended: 'Recomendado',
    'No campaigns found for this filter.': 'No se encontraron campañas para este filtro.',
    'Segment, act fast, and retain more regular diners.': 'Segmenta, actúa rápido y retén más clientes frecuentes.',
    'Customer List': 'Lista de clientes',
    'Customer Name': 'Nombre del cliente',
    'Active Points (Lifetime)': 'Puntos activos (acumulados)',
    'Total Spend with Rewards': 'Gasto total con recompensas',
    'Spend by Points': 'Gasto por puntos',
    'Total Visits': 'Visitas totales',
    'Last Visit': 'Última visita',
    'Upcoming event': 'Próximo evento',
    'Birthday in': 'Cumpleaños en',
    'Anniversary in': 'Aniversario en',
    'Campaign Suggestion': 'Sugerencia de campaña',
    'Select Customer': 'Seleccionar cliente',
    Name: 'Nombre',
    Balance: 'Saldo',
    'Points Earned': 'Puntos ganados',
    Visits: 'Visitas',
    'Visit History': 'Historial de visitas',
    Order: 'Pedido',
    'No visits yet.': 'Aún sin visitas.',
    'Recent Transactions': 'Transacciones recientes',
    'AI preferences saved': 'Preferencias de IA guardadas',
    'Insights refreshed from latest 7-day data': 'Insights actualizados con los últimos 7 días',
    'Loyalty AI': 'IA de Lealtad',
    'Daily Visits (Last 7 Days)': 'Visitas diarias (últimos 7 días)',
    'Revenue Trend (Last 7 Days)': 'Tendencia de ingresos (últimos 7 días)',
    'Customer Segments': 'Segmentos de clientes',
    'Trend data unavailable': 'Datos de tendencia no disponibles',
    'No recommendation available.': 'No hay recomendación disponible.',
    'At-Risk Guests': 'Clientes en riesgo',
    'Visit Growth': 'Crecimiento de visitas',
    'Revenue (7d)': 'Ingresos (7d)',
    'Visits (7d)': 'Visitas (7d)',
    'Context-aware restaurant advisor powered by your real business data.': 'Asesor de restaurante con contexto, impulsado por tus datos reales.',
    pts: 'pts',
    'N/A': 'N/D',
    'No customers yet': 'Aún no hay clientes',
    'No customers found.': 'No se encontraron clientes.',
    'Unable to load rewards data right now.': 'No se pudieron cargar los datos de recompensas.',
    'Please enter a valid order amount.': 'Ingresa un monto de pedido válido.',
    'Order ID must follow ORD-123 format.': 'El ID debe seguir el formato ORD-123.',
    'Points credited successfully.': 'Puntos acreditados correctamente.',
    'Minimum 100 points required.': 'Se requieren mínimo 100 puntos.',
    'Redemption completed successfully.': 'Canje completado con éxito.',
    'Unable to initiate redemption.': 'No se pudo iniciar el canje.',
  },
  ko: {
    'Simulate order credits, redeem in person, and validate pending redemption requests.': '주문 적립 시뮬레이션, 현장 사용, 대기 중 요청 검증을 처리합니다.',
    'Lookup customer by phone or name': '전화번호 또는 이름으로 고객 조회',
    'Simulate & Credit': '시뮬레이션 및 적립',
    'Redeem In Person': '현장 사용',
    'Use Amount': '금액 사용',
    'Use Points': '포인트 사용',
    'AI Tip': 'AI 팁',
    'Offering 10% bonus points increases return visits by ~20%.': '보너스 포인트 10% 제공 시 재방문이 약 20% 증가합니다.',
    'Requested Points': '요청 포인트',
    Channel: '채널',
    'Created At': '생성일',
    Actions: '작업',
    'Voice Agent Loyalty Connect': '보이스 에이전트 로열티 커넥트',
    "Powered by ISO's AI Agent": 'ISO AI 에이전트 제공',
    'Auto-enroll via call: "You earned 500 points worth $5 — say YES to join".': '전화 자동 가입: "500포인트($5)를 받았습니다. YES라고 말해 가입하세요."',
    Agent: '에이전트',
    'All callers': '모든 발신자',
    Members: '회원',
    'Lost bucket': '이탈 버킷',
    'At Risk bucket': '위험 버킷',
    'Active bucket': '활성 버킷',
    'Campaign Activity': '캠페인 활동',
    'Campaign Details': '캠페인 상세',
    'Delivery analytics and recipient status for this campaign.': '이 캠페인의 발송 분석 및 수신자 상태입니다.',
    Targeted: '타겟',
    Conversion: '전환율',
    Revenue: '매출',
    'Campaign Visits': '캠페인 방문',
    'New Users': '신규 사용자',
    'Delivery Log': '전송 로그',
    'Provider SID': '제공자 SID',
    Error: '오류',
    Time: '시간',
    'No delivery records available yet.': '아직 전송 기록이 없습니다.',
    'Eligible Customers': '대상 고객',
    'Audience preview based on current campaign rules.': '현재 캠페인 규칙 기반 대상 미리보기',
    'No eligible customers found.': '대상 고객이 없습니다.',
    'Load More Campaigns': '캠페인 더 보기',
    View: '보기',
    Code: '코드',
    Campaign: '캠페인',
    'Choose a campaign and run it in one click.': '캠페인을 선택하고 한 번에 실행하세요.',
    'Toggle Campaigns': '캠페인 토글',
    Recommended: '추천',
    'No campaigns found for this filter.': '이 필터에 해당하는 캠페인이 없습니다.',
    'Segment, act fast, and retain more regular diners.': '세분화하고 빠르게 실행해 단골을 더 유지하세요.',
    'Customer List': '고객 목록',
    'Customer Name': '고객 이름',
    'Active Points (Lifetime)': '현재 포인트(누적)',
    'Total Spend with Rewards': '리워드 포함 총 지출',
    'Spend by Points': '포인트 사용 지출',
    'Total Visits': '총 방문',
    'Last Visit': '최근 방문',
    'Upcoming event': '다가오는 이벤트',
    'Birthday in': '생일까지',
    'Anniversary in': '기념일까지',
    'Campaign Suggestion': '캠페인 제안',
    'Select Customer': '고객 선택',
    Name: '이름',
    Balance: '잔액',
    'Points Earned': '적립 포인트',
    Visits: '방문',
    'Visit History': '방문 이력',
    Order: '주문',
    'No visits yet.': '아직 방문 기록이 없습니다.',
    'Recent Transactions': '최근 거래',
    'AI preferences saved': 'AI 설정이 저장되었습니다',
    'Insights refreshed from latest 7-day data': '최근 7일 데이터로 인사이트를 새로고침했습니다',
    'Loyalty AI': '로열티 AI',
    'Daily Visits (Last 7 Days)': '일별 방문 (최근 7일)',
    'Revenue Trend (Last 7 Days)': '매출 추이 (최근 7일)',
    'Customer Segments': '고객 세그먼트',
    'Trend data unavailable': '추세 데이터 없음',
    'No recommendation available.': '추천이 없습니다.',
    'At-Risk Guests': '위험 고객',
    'Visit Growth': '방문 증가율',
    'Revenue (7d)': '매출(7일)',
    'Visits (7d)': '방문(7일)',
    'Context-aware restaurant advisor powered by your real business data.': '실제 비즈니스 데이터를 기반으로 한 컨텍스트형 레스토랑 어드바이저.',
    pts: '포인트',
    'N/A': '없음',
    'No customers yet': '고객 없음',
    'No customers found.': '고객을 찾을 수 없습니다.',
    'Unable to load rewards data right now.': '현재 리워드 데이터를 불러올 수 없습니다.',
    'Please enter a valid order amount.': '유효한 주문 금액을 입력하세요.',
    'Order ID must follow ORD-123 format.': '주문 ID는 ORD-123 형식이어야 합니다.',
    'Points credited successfully.': '포인트 적립 완료',
    'Minimum 100 points required.': '최소 100포인트가 필요합니다.',
    'Redemption completed successfully.': '사용이 완료되었습니다.',
    'Unable to initiate redemption.': '사용 시작에 실패했습니다.',
  },
  ja: {
    'Simulate order credits, redeem in person, and validate pending redemption requests.': '注文ポイント付与のシミュレーション、店頭利用、保留中リクエストの承認を行います。',
    'Lookup customer by phone or name': '電話番号または名前で顧客検索',
    'Simulate & Credit': 'シミュレーション＆付与',
    'Redeem In Person': '店頭で利用',
    'Use Amount': '金額で利用',
    'Use Points': 'ポイントで利用',
    'AI Tip': 'AIヒント',
    'Offering 10% bonus points increases return visits by ~20%.': '10%のボーナスポイント提供で再来店が約20%向上します。',
    'Requested Points': '申請ポイント',
    Channel: 'チャネル',
    'Created At': '作成日時',
    Actions: '操作',
    'Voice Agent Loyalty Connect': 'ボイスエージェント ロイヤルティコネクト',
    "Powered by ISO's AI Agent": 'ISOのAIエージェント提供',
    'Auto-enroll via call: "You earned 500 points worth $5 — say YES to join".': '電話自動登録:「$5相当の500ポイントを獲得。YESで参加」',
    Agent: 'エージェント',
    'All callers': 'すべての発信者',
    Members: '会員',
    'Lost bucket': '離脱バケット',
    'At Risk bucket': '要注意バケット',
    'Active bucket': 'アクティブバケット',
    'Campaign Activity': 'キャンペーン履歴',
    'Campaign Details': 'キャンペーン詳細',
    'Delivery analytics and recipient status for this campaign.': 'このキャンペーンの配信分析と受信者ステータスです。',
    Targeted: '対象数',
    Conversion: 'コンバージョン',
    Revenue: '売上',
    'Campaign Visits': 'キャンペーン来店',
    'New Users': '新規ユーザー',
    'Delivery Log': '配信ログ',
    'Provider SID': 'プロバイダ SID',
    Error: 'エラー',
    Time: '時刻',
    'No delivery records available yet.': '配信記録はまだありません。',
    'Eligible Customers': '対象顧客',
    'Audience preview based on current campaign rules.': '現在のルールに基づく対象プレビュー',
    'No eligible customers found.': '対象顧客が見つかりません。',
    'Load More Campaigns': 'キャンペーンをさらに表示',
    View: '表示',
    Code: 'コード',
    Campaign: 'キャンペーン',
    'Choose a campaign and run it in one click.': 'キャンペーンを選んでワンクリックで実行。',
    'Toggle Campaigns': 'キャンペーントグル',
    Recommended: 'おすすめ',
    'No campaigns found for this filter.': 'この条件のキャンペーンはありません。',
    'Segment, act fast, and retain more regular diners.': 'セグメントして素早く実行し、常連を増やしましょう。',
    'Customer List': '顧客リスト',
    'Customer Name': '顧客名',
    'Active Points (Lifetime)': '有効ポイント（累計）',
    'Total Spend with Rewards': '特典込み総支出',
    'Spend by Points': 'ポイント利用額',
    'Total Visits': '総来店',
    'Last Visit': '最終来店',
    'Upcoming event': '近日イベント',
    'Birthday in': '誕生日まで',
    'Anniversary in': '記念日まで',
    'Campaign Suggestion': 'キャンペーン提案',
    'Select Customer': '顧客を選択',
    Name: '名前',
    Balance: '残高',
    'Points Earned': '獲得ポイント',
    Visits: '来店',
    'Visit History': '来店履歴',
    Order: '注文',
    'No visits yet.': '来店履歴はまだありません。',
    'Recent Transactions': '最近の取引',
    'AI preferences saved': 'AI設定を保存しました',
    'Insights refreshed from latest 7-day data': '直近7日データでインサイトを更新しました',
    'Loyalty AI': 'ロイヤルティAI',
    'Daily Visits (Last 7 Days)': '日別来店（過去7日）',
    'Revenue Trend (Last 7 Days)': '売上トレンド（過去7日）',
    'Customer Segments': '顧客セグメント',
    'Trend data unavailable': 'トレンドデータなし',
    'No recommendation available.': '推奨はありません。',
    'At-Risk Guests': '要注意顧客',
    'Visit Growth': '来店成長',
    'Revenue (7d)': '売上（7日）',
    'Visits (7d)': '来店（7日）',
    'Context-aware restaurant advisor powered by your real business data.': '実データに基づくコンテキスト対応レストランアドバイザー。',
    pts: 'pt',
    'N/A': '該当なし',
    'No customers yet': '顧客がまだいません',
    'No customers found.': '顧客が見つかりません。',
    'Unable to load rewards data right now.': '現在リワードデータを読み込めません。',
    'Please enter a valid order amount.': '有効な注文金額を入力してください。',
    'Order ID must follow ORD-123 format.': '注文IDは ORD-123 形式で入力してください。',
    'Points credited successfully.': 'ポイント付与に成功しました。',
    'Minimum 100 points required.': '最低100ポイントが必要です。',
    'Redemption completed successfully.': '利用処理が完了しました。',
    'Unable to initiate redemption.': '利用処理を開始できませんでした。',
  },
};

const AUTO_PHRASE_TRANSLATIONS = {
  zh: {
    'Run pre-built campaigns in one click.': '一键运行预设活动。',
    'Reward High-Value Customers': '奖励高价值顾客',
    'Loyalty AI is running a live VIP campaign setup based on your latest customer data.': 'Loyalty AI 正在根据你最新的顾客数据实时配置 VIP 活动。',
    'Top customers detected': '已识别顶级顾客',
    'Finding your top customers…': '正在查找你的顶级顾客…',
    'Understanding their recent activity…': '正在分析他们近期行为…',
    'Creating special rewards for them…': '正在为他们创建专属奖励…',
    'Getting your campaign ready…': '正在准备活动…',
    'Need deeper details? Open Loyalty AI for breakdown.': '需要更深入的细节？打开 Loyalty AI 查看分析。',
    'Open Loyalty AI': '打开 Loyalty AI',
    'Your Personal AI Assistant': '你的个人 AI 助手',
    'Repeat Visit Lift': '复访提升率',
    'Revenue from Loyalty': '忠诚度营收',
    'AOV Trend': 'AOV 趋势',
    'Peak Dining Hour': '高峰用餐时段',
    'Top Redeemed Item': '最常兑换项目',
    'Most popular reward': '最受欢迎奖励',
    'Quick Actions': '快捷操作',
    'AI Auto-Campaigns — Coming Soon': 'AI 自动活动 — 即将推出',
    'Occasion-Based': '场景类',
    Behavioural: '行为类',
    'Search by phone number': '按手机号搜索',
    'Auto detected customer': '自动识别顾客',
    'Best Available Benefit': '最佳可用权益',
    'Tap to Redeem': '刷卡兑换',
    'Select & Credit': '选择并发放积分',
    'Customer Redemption Queue': '顾客兑换队列',
    'Log out of FlyBack?': '确认退出 FlyBack？',
    'You can sign back in any time from this device.': '你可随时在此设备重新登录。',
    'Log out': '退出',
  },
  es: {
    'Run pre-built campaigns in one click.': 'Ejecuta campañas preconfiguradas con un clic.',
    'Reward High-Value Customers': 'Recompensar clientes de alto valor',
    'Loyalty AI is running a live VIP campaign setup based on your latest customer data.': 'Loyalty AI está configurando una campaña VIP en vivo con tus datos más recientes.',
    'Top customers detected': 'Clientes top detectados',
    'Finding your top customers…': 'Buscando a tus mejores clientes…',
    'Understanding their recent activity…': 'Analizando su actividad reciente…',
    'Creating special rewards for them…': 'Creando recompensas especiales para ellos…',
    'Getting your campaign ready…': 'Preparando tu campaña…',
    'Need deeper details? Open Loyalty AI for breakdown.': '¿Necesitas más detalle? Abre Loyalty AI para el desglose.',
    'Open Loyalty AI': 'Abrir Loyalty AI',
    'Your Personal AI Assistant': 'Tu asistente personal de IA',
    'Repeat Visit Lift': 'Mejora de visitas repetidas',
    'Revenue from Loyalty': 'Ingresos por lealtad',
    'AOV Trend': 'Tendencia AOV',
    'Peak Dining Hour': 'Hora pico de consumo',
    'Top Redeemed Item': 'Ítem más canjeado',
    'Most popular reward': 'Recompensa más popular',
    'Quick Actions': 'Acciones rápidas',
    'AI Auto-Campaigns — Coming Soon': 'Auto-campañas IA — Próximamente',
    'Occasion-Based': 'Por ocasión',
    Behavioural: 'Conductual',
    'Search by phone number': 'Buscar por teléfono',
    'Auto detected customer': 'Cliente detectado automáticamente',
    'Best Available Benefit': 'Mejor beneficio disponible',
    'Tap to Redeem': 'Tocar para canjear',
    'Select & Credit': 'Seleccionar y acreditar',
    'Customer Redemption Queue': 'Cola de canjes de clientes',
    'Log out of FlyBack?': '¿Cerrar sesión en FlyBack?',
    'You can sign back in any time from this device.': 'Puedes volver a iniciar sesión en cualquier momento desde este dispositivo.',
    'Log out': 'Cerrar sesión',
  },
  ko: {
    'Run pre-built campaigns in one click.': '사전 구성된 캠페인을 한 번에 실행하세요.',
    'Reward High-Value Customers': '고가치 고객 보상',
    'Loyalty AI is running a live VIP campaign setup based on your latest customer data.': 'Loyalty AI가 최신 고객 데이터를 기반으로 VIP 캠페인을 실시간 설정 중입니다.',
    'Top customers detected': '상위 고객 감지됨',
    'Finding your top customers…': '상위 고객을 찾는 중…',
    'Understanding their recent activity…': '최근 활동을 분석하는 중…',
    'Creating special rewards for them…': '맞춤 보상을 생성하는 중…',
    'Getting your campaign ready…': '캠페인을 준비하는 중…',
    'Need deeper details? Open Loyalty AI for breakdown.': '더 자세한 내용이 필요하신가요? Loyalty AI에서 확인하세요.',
    'Open Loyalty AI': 'Loyalty AI 열기',
    'Your Personal AI Assistant': '개인 AI 어시스턴트',
    'Repeat Visit Lift': '재방문 상승률',
    'Revenue from Loyalty': '로열티 매출',
    'AOV Trend': 'AOV 추세',
    'Peak Dining Hour': '피크 다이닝 시간',
    'Top Redeemed Item': '가장 많이 사용된 항목',
    'Most popular reward': '가장 인기 있는 리워드',
    'Quick Actions': '빠른 실행',
    'AI Auto-Campaigns — Coming Soon': 'AI 자동 캠페인 — 출시 예정',
    'Occasion-Based': '이벤트 기반',
    Behavioural: '행동 기반',
    'Search by phone number': '전화번호로 검색',
    'Auto detected customer': '자동 감지 고객',
    'Best Available Benefit': '최적 혜택',
    'Tap to Redeem': '탭으로 사용',
    'Select & Credit': '선택 및 적립',
    'Customer Redemption Queue': '고객 사용 요청 큐',
    'Log out of FlyBack?': 'FlyBack에서 로그아웃하시겠습니까?',
    'You can sign back in any time from this device.': '이 기기에서 언제든 다시 로그인할 수 있습니다.',
    'Log out': '로그아웃',
  },
  ja: {
    'Run pre-built campaigns in one click.': '事前設定済みキャンペーンをワンクリックで実行。',
    'Reward High-Value Customers': '高価値顧客に特典配布',
    'Loyalty AI is running a live VIP campaign setup based on your latest customer data.': 'Loyalty AI が最新顧客データをもとにVIPキャンペーンをリアルタイム設定中です。',
    'Top customers detected': '上位顧客を検出',
    'Finding your top customers…': '上位顧客を特定中…',
    'Understanding their recent activity…': '最近の行動を分析中…',
    'Creating special rewards for them…': '特別特典を作成中…',
    'Getting your campaign ready…': 'キャンペーンを準備中…',
    'Need deeper details? Open Loyalty AI for breakdown.': 'より詳しい内容は Loyalty AI で確認できます。',
    'Open Loyalty AI': 'Loyalty AI を開く',
    'Your Personal AI Assistant': 'あなたのAIアシスタント',
    'Repeat Visit Lift': '再来店リフト',
    'Revenue from Loyalty': 'ロイヤルティ売上',
    'AOV Trend': 'AOVトレンド',
    'Peak Dining Hour': 'ピーク来店時間',
    'Top Redeemed Item': '最も利用された特典',
    'Most popular reward': '人気No.1特典',
    'Quick Actions': 'クイックアクション',
    'AI Auto-Campaigns — Coming Soon': 'AI自動キャンペーン — 近日公開',
    'Occasion-Based': 'イベント系',
    Behavioural: '行動系',
    'Search by phone number': '電話番号で検索',
    'Auto detected customer': '自動検出顧客',
    'Best Available Benefit': '最適な利用特典',
    'Tap to Redeem': 'タップで利用',
    'Select & Credit': '選択して付与',
    'Customer Redemption Queue': '顧客利用キュー',
    'Log out of FlyBack?': 'FlyBack からログアウトしますか？',
    'You can sign back in any time from this device.': 'この端末からいつでも再ログインできます。',
    'Log out': 'ログアウト',
  },
};

const AUTO_TERM_TRANSLATIONS = {
  zh: {
    run: '运行',
    campaign: '活动',
    campaigns: '活动',
    customer: '顾客',
    customers: '顾客',
    active: '活跃',
    risk: '风险',
    lost: '流失',
    reward: '奖励',
    rewards: '奖励',
    redeem: '兑换',
    redemptions: '兑换',
    visits: '到店',
    visit: '到店',
    revenue: '营收',
    trend: '趋势',
    average: '平均',
    order: '订单',
    value: '价值',
    quick: '快捷',
    actions: '操作',
    settings: '设置',
    search: '搜索',
    save: '保存',
    cancel: '取消',
    approve: '批准',
    reject: '拒绝',
    points: '积分',
    amount: '金额',
    details: '详情',
    completed: '已完成',
    all: '全部',
    sent: '已发送',
    delivered: '已送达',
    date: '日期',
    phone: '手机号',
    status: '状态',
    restaurant: '餐厅',
    owner: '店主',
    loyalty: '忠诚度',
  },
  es: {
    run: 'ejecutar',
    campaign: 'campaña',
    campaigns: 'campañas',
    customer: 'cliente',
    customers: 'clientes',
    active: 'activo',
    risk: 'riesgo',
    lost: 'perdido',
    reward: 'recompensa',
    rewards: 'recompensas',
    redeem: 'canjear',
    redemptions: 'canjes',
    visits: 'visitas',
    visit: 'visita',
    revenue: 'ingresos',
    trend: 'tendencia',
    average: 'promedio',
    order: 'pedido',
    value: 'valor',
    quick: 'rápido',
    actions: 'acciones',
    settings: 'configuración',
    search: 'buscar',
    save: 'guardar',
    cancel: 'cancelar',
    approve: 'aprobar',
    reject: 'rechazar',
    points: 'puntos',
    amount: 'monto',
    details: 'detalles',
    completed: 'completado',
    all: 'todos',
    sent: 'enviado',
    delivered: 'entregado',
    date: 'fecha',
    phone: 'teléfono',
    status: 'estado',
    restaurant: 'restaurante',
    owner: 'propietario',
    loyalty: 'lealtad',
  },
  ko: {
    run: '실행',
    campaign: '캠페인',
    campaigns: '캠페인',
    customer: '고객',
    customers: '고객',
    active: '활성',
    risk: '위험',
    lost: '이탈',
    reward: '보상',
    rewards: '리워드',
    redeem: '사용',
    redemptions: '사용',
    visits: '방문',
    visit: '방문',
    revenue: '매출',
    trend: '추세',
    average: '평균',
    order: '주문',
    value: '값',
    quick: '빠른',
    actions: '실행',
    settings: '설정',
    search: '검색',
    save: '저장',
    cancel: '취소',
    approve: '승인',
    reject: '거절',
    points: '포인트',
    amount: '금액',
    details: '상세',
    completed: '완료',
    all: '전체',
    sent: '발송',
    delivered: '전달',
    date: '날짜',
    phone: '전화번호',
    status: '상태',
    restaurant: '레스토랑',
    owner: '오너',
    loyalty: '로열티',
  },
  ja: {
    run: '実行',
    campaign: 'キャンペーン',
    campaigns: 'キャンペーン',
    customer: '顧客',
    customers: '顧客',
    active: 'アクティブ',
    risk: 'リスク',
    lost: '離脱',
    reward: '特典',
    rewards: '特典',
    redeem: '利用',
    redemptions: '利用',
    visits: '来店',
    visit: '来店',
    revenue: '売上',
    trend: 'トレンド',
    average: '平均',
    order: '注文',
    value: '値',
    quick: 'クイック',
    actions: '操作',
    settings: '設定',
    search: '検索',
    save: '保存',
    cancel: 'キャンセル',
    approve: '承認',
    reject: '却下',
    points: 'ポイント',
    amount: '金額',
    details: '詳細',
    completed: '完了',
    all: 'すべて',
    sent: '送信',
    delivered: '配信',
    date: '日付',
    phone: '電話',
    status: '状態',
    restaurant: 'レストラン',
    owner: 'オーナー',
    loyalty: 'ロイヤルティ',
  },
};

function readLanguage() {
  if (typeof window === 'undefined') return 'en';
  return window.localStorage.getItem('flyback_ui_lang') || 'en';
}

export function useUiLanguage() {
  const [language, setLanguage] = useState(readLanguage);

  useEffect(() => {
    const onCustom = () => setLanguage(readLanguage());
    const onStorage = (event) => {
      if (!event || event.key === 'flyback_ui_lang') setLanguage(readLanguage());
    };
    window.addEventListener('flyback-language-change', onCustom);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('flyback-language-change', onCustom);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const t = useMemo(() => {
    const table = { ...(DICT[language] || {}), ...(EXTRA_DICT[language] || {}), ...(AUTO_PHRASE_TRANSLATIONS[language] || {}) };
    const keys = Object.keys(table).sort((a, b) => b.length - a.length);
    const termTable = AUTO_TERM_TRANSLATIONS[language] || {};
    return (text) => {
      const raw = String(text ?? '');
      if (table[raw]) return table[raw];
      let next = raw;
      keys.forEach((key) => {
        if (!key) return;
        if (next.includes(key)) {
          next = next.split(key).join(table[key]);
        }
      });
      if (language !== 'en') {
        next = next.replace(/[A-Za-z][A-Za-z&/-]*/g, (token) => {
          const exact = termTable[token];
          if (exact) return exact;
          const lower = termTable[token.toLowerCase()];
          if (!lower) return token;
          if (token[0] === token[0]?.toUpperCase()) {
            return lower.charAt(0).toUpperCase() + lower.slice(1);
          }
          return lower;
        });
      }
      return next;
    };
  }, [language]);

  return { language, t };
}
